import { SectionError, SectionHeader } from "./components";
import Section from "./Section";

Section.Header = SectionHeader;
Section.Error = SectionError;

export default Section;
